import "../../assets/css/navbar.css";
import React from "react";
import { useSelector } from "react-redux";
import classnames from "classnames";
import {
  Collapse,
  NavbarBrand,
  Navbar,
  Nav,
  Container,
  NavItem,
  NavLink,
} from "reactstrap";
import NavbarItem from "./NavbarItem";
import Dropdown from "react-multilevel-dropdown";
import LaguageBar from "./LanguageBar";

import { staticData } from "managers/staticDataManager";
import MobileNavbar from "./MobileNavbar";

import { useNavigateUrl } from "managers/utilManager";

function PublicNavbar() {
  const navigateUrl = useNavigateUrl();
  const { language } = useSelector((state) => state.account);
  const { isChannelInitialized, channel } = useSelector(
    (state) => state.staticData
  );

  const [navbarCollapse, setNavbarCollapse] = React.useState(false);

  const toggleNavbarCollapse = () => {
    setNavbarCollapse(!navbarCollapse);
    document.documentElement.classList.toggle("nav-open");
  };

  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 992);
  React.useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const getMenuData = (lng) => {
    const term =
      channel && channel.localizedTerms
        ? channel.localizedTerms.find((lt) => lt.languageId === lng.languageId)
        : null;

    if (term?.menuJson) return JSON.parse(term.menuJson);
    return [];
  };

  const closeMobileNavIfNeeded = () => {
    if (isMobile) {
      setNavbarCollapse(false);
      document.documentElement.classList.remove("nav-open");
    }
  };

  const handleClick = (e, item) => {
    e?.preventDefault?.();
    navigateUrl(item?.url);
    closeMobileNavIfNeeded();
  };

  const menuData = isChannelInitialized ? getMenuData(language) : [];

  React.useEffect(() => {}, [
    isChannelInitialized,
    language?.languageId,
    channel?.code,
  ]);

  return (
    <Navbar
      fixed=""
      color-on-scroll="300"
      expand="lg"
      className="d-flex flex-column"
      style={{ backgroundColor: "#EBECF0" }}
    >
      <div className="header-panel-container w-100">
        <Container className="container-sm">
          <Nav className="w-100">
            <NavItem>
              <NavLink
                href="https://mse.mk"
                target="_blank"
                className="header-panel__link font-weight-bold"
              >
                {staticData.loadTerms(useSelector, "ISSUER_NAVBAR_MSE_LABEL")}
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                href="http://bestnet.com.mk"
                target="_blank"
                className="header-panel__link font-weight-bold"
              >
                {staticData.loadTerms(
                  useSelector,
                  "ISSUER_NAVBAR_BESTNET_LABEL"
                )}
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  navigateUrl("/about");
                  closeMobileNavIfNeeded();
                }}
                className="header-panel__link font-weight-bold"
              >
                {staticData.loadTerms(
                  useSelector,
                  `ISSUER_NAVBAR_ABOUT_LABEL_${channel?.code}`
                )}
              </NavLink>
            </NavItem>

            <LaguageBar />
          </Nav>
        </Container>
      </div>

      <Container className="container-sm main-menu-container">
        <div className="navbar-translate">
          <NavbarBrand
            data-placement="bottom"
            onClick={(e) => {
              e.preventDefault();
              navigateUrl();
              closeMobileNavIfNeeded();
            }}
            title="by MSE"
            margin-left="10px"
          >
            {channel?.code}
          </NavbarBrand>

          <button
            aria-expanded={navbarCollapse}
            className={classnames("navbar-toggler navbar-toggler", {
              toggled: navbarCollapse,
            })}
            onClick={toggleNavbarCollapse}
          >
            <span className="navbar-toggler-bar bar1" />
            <span className="navbar-toggler-bar bar2" />
            <span className="navbar-toggler-bar bar3" />
          </button>
        </div>

        <Collapse
          className="justify-content-end"
          navbar
          isOpen={navbarCollapse}
        >
          <Nav navbar>
            {isMobile ? (
              <div className="mobile-nav">
                <MobileNavbar
                  items={menuData}
                  onNavigate={(item) => {
                    navigateUrl(item?.url);
                    closeMobileNavIfNeeded();
                  }}
                />
              </div>
            ) : (
              menuData.map((item) =>
                item.children ? (
                  <Dropdown
                    key={item.id}
                    data-key={`${item.url}`}
                    title={item.title}
                    className="header-panel__link font-weight-bold dropdown-navlink"
                  >
                    <NavbarItem data={item.children} />
                  </Dropdown>
                ) : (
                  <NavLink
                    href="#"
                    key={item.id}
                    data-key={`${item.url}`}
                    title={item.title}
                    onClick={(e) => handleClick(e, item)}
                    className="header-panel__link font-weight-bold"
                  >
                    {item.title}
                  </NavLink>
                )
              )
            )}
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}

export default PublicNavbar;
